import { responsive as responsiceConstant } from 'containers/CreativePreview/constants';

import React from 'react';
import { StyledCarousel } from './style';

import Asset from './Asset';

function Carousel({ urlList, responsive = responsiceConstant as any }) {
  return (
    <StyledCarousel
      responsive={responsive}
      className="creative-screenshot-container"
    >
      {urlList.map(({ url, label, previewUrl, playbackRate, placeholder }) => (
        <Asset
          url={url}
          label={label}
          previewUrl={previewUrl}
          playbackRate={playbackRate}
          placeholder={placeholder}
        />
      ))}
    </StyledCarousel>
  );
}

export default Carousel;
